module.exports = __webpack_public_path__ + "static/media/caret-daily.96bf2333.svg";